import { render, staticRenderFns } from "./Seating.vue?vue&type=template&id=06260ec2&"
import script from "./Seating.vue?vue&type=script&lang=js&"
export * from "./Seating.vue?vue&type=script&lang=js&"
import style0 from "./Seating.vue?vue&type=style&index=0&id=06260ec2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports